import * as actionTypes from "../actions/actionTypes";
import peerScoreSet from "../../libs/peerScoreSets/peerScoreSets";
import { updateObject } from "../utility";
import QuestionSets from "../../libs/QuestionSets";
import { bindActionCreators } from "redux";

const initialState = {
  overallScore: 0,
  specificScore: [0, 0, 0, 0, 0, 0],
  peerScore: [0, 0, 0, 0, 0, 0],
};

const update_score = (state = initialState, action) => {
  const arr = [...state.specificScore];

  arr[action.index] = action.value;

  const avgScore = arr.reduce((total, num) => total + num) / arr.length;

  return updateObject(state, {
    overallScore: avgScore,
    specificScore: arr,
  });
};

const update_peerscore = (state = initialState, action) => {
  return updateObject(state, {
    peerScore: peerScoreSet[action.role],
  });
};

const init_scores = (state = initialState, action) => {
  return updateObject(state, {
    specificScore: action.scores,
  });
};

const reset_scores = (state = initialState, action) => {
  const role = action.role === "None" ? "Select Your Role" : action.role;

  // const initArr = new Array(QuestionSets[role].length);

  // const initArr2 = initArr.map(e => {return 0});

  // console.log(initArr2, '99999999');
  const specificScore = [];

  for (let i = 0; i < QuestionSets[role].length; i++) {
    specificScore.push(0);
  }

  return updateObject(state, {
    specificScore,
  });
};

// const update_score1 = (state = initialState, action) => {
//     return updateObject(state, {
//         specificScore: action.scores,
//     });
// };

const reducer = (state = initialState, action) => {
  if (action.type === actionTypes.UPDATE_SCORE) {
    return update_score(state, action);
  }
  if (action.type === actionTypes.RESET_SCORES) {
    return reset_scores(state, action);
  }
  if (action.type === actionTypes.INIT_SCORES) {
    return init_scores(state, action);
  }
  if (action.type === actionTypes.UPDATE_PEERSCORE) {
    return update_peerscore(state, action);
  }
  // if(actionltype === actionTypes.UPDATE_SCORE1){
  //     return update_score1(state, action);
  // }

  return state;
};

export default reducer;
